/** Philippine peso display ( storefront ). */
export function formatPeso(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  return `₱${n.toLocaleString('en-PH', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })}`;
}
